define((require) => {
    "use strict";

    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");

    /**
     * The animation controller for fading out.
     *
     * @class FadeOutAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.OUTRO, // We're fading to 0.0, hence "outro"

        descriptor() {
            return {
                to: {opacity: 0}
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/fadeOut/FadeOutAnimationController.js